export default "__VITE_ASSET__1a3ca845__"